var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2091 12.8955L21.1716 11.0618L22.9877 3.95623C23.2147 3.26859 22.7607 2.35175 22.0796 2.35175L14.1341 0.059626C13.453 -0.169586 12.5449 0.288824 12.5449 0.976461L10.7288 8.08205L3.69132 6.24835C3.01027 6.01914 2.10225 6.47758 2.10225 7.16522L0.059049 14.7292C-0.167967 15.4168 0.28612 16.3337 0.967169 16.3337L8.00461 18.1674L6.18851 25.273C5.9615 25.9606 6.41551 26.8774 7.09656 26.8774L14.5881 28.9404C15.2692 29.1696 16.1772 28.7111 16.1772 28.0235L17.9934 20.9179L25.0308 22.7516C25.7119 22.9808 26.62 22.5224 26.62 21.8348L28.6631 14.2708C29.3441 13.8124 28.8901 13.1247 28.2091 12.8955Z",
    fill: "#FCC947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6c320c1cfe205e707b121002f599be8d.svg";
export { ForwardRef as ReactComponent };